import { PwaInstallPrompt } from "@/components/PwaInstallPrompt";
import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";

export function AppLayout() {
  return (
    <div className="flex h-screen bg-zinc-50">
      <PwaInstallPrompt />

      {/* Sidebar */}
      <Sidebar />

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header */}
        <Header />

        {/* Page Content — reserve scrollbar space so switching between short and
            long pages doesn't shift the layout (the source of the flicker). */}
        <main className="flex-1 overflow-y-auto" style={{ scrollbarGutter: "stable" }}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
